var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGroupLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 18.334C1.6665 14.6521 4.65127 11.6673 8.33317 11.6673C12.0151 11.6673 14.9998 14.6521 14.9998 18.334H13.3332C13.3332 15.5726 11.0946 13.334 8.33317 13.334C5.57175 13.334 3.33317 15.5726 3.33317 18.334H1.6665ZM8.33317 10.834C5.57067 10.834 3.33317 8.59648 3.33317 5.83398C3.33317 3.07148 5.57067 0.833984 8.33317 0.833984C11.0957 0.833984 13.3332 3.07148 13.3332 5.83398C13.3332 8.59648 11.0957 10.834 8.33317 10.834ZM8.33317 9.16732C10.1748 9.16732 11.6665 7.67565 11.6665 5.83398C11.6665 3.99232 10.1748 2.50065 8.33317 2.50065C6.4915 2.50065 4.99984 3.99232 4.99984 5.83398C4.99984 7.67565 6.4915 9.16732 8.33317 9.16732ZM15.2363 12.253C17.5535 13.2974 19.1665 15.6273 19.1665 18.334H17.4998C17.4998 16.304 16.2901 14.5566 14.5522 13.7732L15.2363 12.253ZM14.6633 2.84499C16.3285 3.53151 17.4998 5.17033 17.4998 7.08398C17.4998 9.47582 15.67 11.4383 13.3332 11.6487V9.97115C14.7471 9.76915 15.8332 8.55398 15.8332 7.08398C15.8332 5.93344 15.1678 4.93901 14.2007 4.46428L14.6633 2.84499Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroupLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/group-line.e7c6e65e.svg";
export { ForwardRef as ReactComponent };